import { Fragment } from "react"
import moment from "moment"
import HtmlParser from "react-html-parser"
import {
	SVOD_ID_RAIL_PRODUCTS_STILL_AVAILABLE,
	SVOD_RAIL_BONUSES,
	SVOD_RAIL_PRODUCTS_MOTS_VIEWED,
	SVOD_RAIL_TVOD,
	metadata
} from "lacinetek-common/src/metadata"

import { Products } from "components/common"
import { BlockTitle } from "./block-title"
import { SliderRailProduct } from "./rail-products"
import { ProductCard } from "./product-card"
import { SliderRailBonus } from "./rail-bonus"
import { SliderProductsMostViewed } from "./slider-products-most-viewed"

export const SliderSubscription = ({ block, className, isOverlay = false }) => {
	return (
		<section id={block.id} className={className}>
			<BlockTitle block={block} />
			{
				block.description !== ""
				&& HtmlParser(block.description)
			}
			<DisplaySliders	rails={block.children.items} isOverlay={isOverlay} />
		</section>
	)
}

export const DisplaySliders = ({ rails, isOverlay }) => {
	return rails.map(rail => {
		if (metadata(rail, SVOD_RAIL_TVOD) === "Oui") {
			return null
		}

		if (metadata(rail, SVOD_RAIL_BONUSES) !== undefined) {
			const parseIds = metadata(rail, SVOD_RAIL_BONUSES).split(",")

			if (!parseIds.length > 0) {
				return null
			}

			return (
				<Fragment key={`rail-${rail.id}`}>
					<BlockTitle
						block={rail}
						rail
					/>
					<SliderRailBonus
						bonusIds={parseIds}
					/>
				</Fragment>
			)
		}

		if(metadata(rail, SVOD_RAIL_PRODUCTS_MOTS_VIEWED)) {
			return <SliderProductsMostViewed rail={rail} isOverlay={isOverlay} />
		}

		if (!rail.products.items.length > 0) {
			return null
		}

		if (rail.products.items.length === 1) {
			return (
				<Fragment key={`rail-single-product-${rail.id}`}>
					<BlockTitle
						block={rail}
						rail
					/>
					<Products
						products={rail.products.items}
						loading={false}
						getVideoIds
					>
						{products => <ProductCard product={products[0]} />}
					</Products>
				</Fragment>
			)
		}

		if(rail.id == SVOD_ID_RAIL_PRODUCTS_STILL_AVAILABLE) {
			rail.products.items.sort((productA, productB) => {
					const endDateA = productA.metadata.find(metadata => metadata.name === "date fin")?.value
					const endDateB = productB.metadata.find(metadata => metadata.name === "date fin")?.value
					const dateA = endDateA ? moment(endDateA, "DD/MM", true) : null
					const dateB = endDateB ? moment(endDateB, "DD/MM", true) : null

					if (!dateA?.isValid()) return dateB?.isValid() ? 1 : 0
					if (!dateB?.isValid()) return -1

					return dateA.diff(dateB)
				})
		}

		return (
			<Fragment key={`rail-${rail.id}`}>
				<BlockTitle
					block={rail}
					rail
				/>
				<SliderRailProduct
					productIds={rail.products.items}
					withPreview
					isOverlay={isOverlay}
					isSvod
				/>
			</Fragment>
		)
	})
}
